var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('router-view'),_c('Footer'),_c('NearestPharmacy'),_c('ThereIsNoDrugStores'),_c('CardAlreadyExist'),_c('PhoneAlreadyExist'),_c('CardDoesntExist'),_c('CardDoesntFind'),_c('Hotline'),_c('info'),_c('Cookies')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }